import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class BustypeResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  search(query = "", params) {
    return this.$resource(apis.bustype + "autocomplete/").get(
      assign(params, { query })
    );
  }

  getAll(options) {
    return this.$resource(apis.bustype).get(options);
  }

  get(id) {
    return this.$resource(apis.bustype + id).get();
  }

  getVehicleTypes() {
    return this.$resource(apis.bustype + "vehicle_types/").get();
  }

  post(item) {
    return this.$resource(apis.bustype).save(item);
  }

  update(id, item) {
    return this.$resource(apis.bustype + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateAction(id, item) {
    return this.$resource(apis.bustype + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default BustypeResource;



// WEBPACK FOOTER //
// ./src/resources/bustype/bustype.resource.js